import { useState } from "react";

export default function Switcher({
  firstLabel,
  secondLabel,
  onSwitchChange,
}: {
  firstLabel: string;
  secondLabel: string;
    onSwitchChange: (isChecked: boolean) => void;
}) {
  const [currenValue, setCurrentValue] = useState(firstLabel);

  return (
    <>
      <label className="inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={currenValue === secondLabel}
          onChange={() => {
            setCurrentValue((prev) =>
              prev === firstLabel ? secondLabel : firstLabel
            );
            onSwitchChange(currenValue === firstLabel);
          }}
          className="sr-only peer"
        />
        {firstLabel}
        <div className="relative w-11 h-6 bg-txtSecondary/30 rounded-full peer mx-2 peer-checked:bg-[#415795] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all"></div>

        {secondLabel}
      </label>
    </>
  );
}
